import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StyleSheet, View, Text } from './components/base_components';
import { BusyOverlay, useBusy } from './components/busy_component';
import ProgressSpinner from './components/progress_spinner';
import DialogScreen from './components/dialog_screen';
import InlineTextButton from './components/buttons/inline_text_button';
import TextButton from './components/buttons/text_button';

import MediaGrantListScreen from './media_grant_list_screen';

import UserStore from './stores/user_store';

const styles = StyleSheet.create({
  homeScreen: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  body: { flex: 1, alignSelf: 'stretch' },
  title: { color: '#333', fontSize: '2rem', fontWeight: '600' },
  subtitle: {
    marginTop: '2rem',
    alignSelf: 'flex-start',
    color: '#333',
    fontSize: '1.5rem',
    fontWeight: '400',
  },
  button: { marginTop: '3rem', alignSelf: 'stretch' },
  line: {
    marginTop: '2rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: { color: '#1b2727', fontSize: '1.5rem', fontWeight: '400' },
  linkText: {
    marginLeft: '0.5rem',
    color: 'var(--link-text-color)',
    fontSize: '1.5rem',
    fontWeight: '500',
    textDecoration: 'underline',
  },
});

export default function HomeScreen() {
  const user = UserStore.useUser();
  const org = UserStore.useOrg();
  const [is_busy, setBusy, clearBusy] = useBusy();
  const navigate = useNavigate();

  function _onLogoutPress() {
    if (setBusy()) {
      UserStore.logout(() => {
        clearBusy();
      });
    }
  }
  function _onSignupPress() {
    navigate('/signup');
  }
  const logout = (
    <View style={styles.line}>
      <Text style={styles.text}>Otherwise you can logout now.</Text>
      <InlineTextButton
        style={styles.linkText}
        text='Logout'
        onPress={_onLogoutPress}
      />
    </View>
  );

  let content: any = null;
  if (!user) {
    content = <ProgressSpinner />;
  } else if (org?.plan_id === null && org?.is_admin) {
    content = (
      <View style={styles.homeScreen}>
        <DialogScreen title='Welcome to Maxlo'>
          <Text style={styles.subtitle}>
            It looks like your Organization isn't signed up for a plan yet.
          </Text>
          <Text style={styles.subtitle}>
            Please contact support and get assigned a plan to use your
            organization.
          </Text>
          <TextButton
            style={styles.button}
            type='blue'
            text='Continue Sign Up'
            onPress={_onSignupPress}
          />
          {logout}
        </DialogScreen>
        <BusyOverlay isBusy={is_busy} />
      </View>
    );
  } else if (org?.plan_id === null) {
    content = (
      <View style={styles.homeScreen}>
        <DialogScreen title='Welcome to Maxlo'>
          <Text style={styles.subtitle}>
            It looks like your Organization isn't signed up for a plan yet.
          </Text>
          <Text style={styles.subtitle}>
            Please contact support and get assigned a plan to use your
            organization.
          </Text>
          {logout}
        </DialogScreen>
        <BusyOverlay isBusy={is_busy} />
      </View>
    );
  } else if (user?.org_list?.length > 0) {
    content = <MediaGrantListScreen />;
  } else {
    content = (
      <View style={styles.homeScreen}>
        <DialogScreen title='Welcome to Maxlo'>
          <Text style={styles.subtitle}>
            It looks like you're not a member of an Organization yet.
          </Text>
          <Text style={styles.subtitle}>
            If you have an organization administrator, ask them to add your
            email ({user.email}) to the organization.
          </Text>
          {logout}
        </DialogScreen>
        <BusyOverlay isBusy={is_busy} />
      </View>
    );
  }
  return content;
}
